import { $layoutContainer } from "../../router";

export function VerifyOverlay() {
  function render() {
    return /*html*/`
    <div id="verify-overlay"
      class="size-full fixed inset-0 z-[199] flex items-center justify-center"
      role="dialog" tabindex="-1">
      <div class="text-gray-800 dark:text-gray-100">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-loader-circle size-10 animate-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
      </div>
    </div>
    `;
  }

  function show() {
    $layoutContainer.insertAdjacentHTML("beforeend", render());
  }

  function hide() {
    const overlay = document.getElementById("verify-overlay");
    if (overlay) {
      overlay.remove();
    }
  }

  return { render, show, hide };
}